import styled from "styled-components";
import FlashOnIcon from "@mui/icons-material/FlashOn";

const ChangeIcon = styled(FlashOnIcon)`
  color: ${(p) => p.theme.palette.info.main};
  margin: 0 0 10px 10px;
`;

export default ChangeIcon;
